import { FC, useState } from 'react';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import { useDossieService } from '../../../../../../use-cases/dossie';

export interface IConsultaOnlineButtonProps {
  documento: string;
  dataNascimento?: string;
  dataAbertura?: string;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const ConsultaOnlineButton: FC<IConsultaOnlineButtonProps> = ({
  documento,
  dataNascimento,
  dataAbertura,
  onSuccess,
  onError,
}) => {
  const { consultarReceitaOnline } = useDossieService();
  const [loading, setLoading] = useState(false);

  const doc = (documento);

  const handleConsultaOnline = async () => {
    if (!doc) return;
    try {
      setLoading(true);
      await consultarReceitaOnline({
        documento: doc,
        dataNascimento,
        dataAbertura,
      });

      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error('Erro na consulta online da Receita Federal:', err);
      if (onError) {
        onError(err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Realizar consulta online na Receita Federal" arrow>
      <span>
        <Button
          variant="contained"
          size="small"
          disabled={loading || !doc}
          onClick={handleConsultaOnline}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <LanguageRoundedIcon sx={{ fontSize: 18 }} />
            )
          }
          sx={{
            backgroundColor: '#723989',
            color: '#ffffff',
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.8125rem',
            px: 2,
            py: 0.6,
            boxShadow: '0 2px 8px rgba(114, 57, 137, 0.2)',
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: '#5c2d6e',
              boxShadow: '0 4px 12px rgba(114, 57, 137, 0.3)',
            },
            '&.Mui-disabled': {
              backgroundColor: '#e2d9e8',
              color: '#8e7a99',
            },
          }}
        >
          {loading ? 'Consultando...' : 'Consulta Online'}
        </Button>
      </span>
    </Tooltip>
  );
};
